import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-auth-phone",
  "use": "icon-auth-phone-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-auth-phone\"><path d=\"M940.992 172.672L531.904 6.912a53.568 53.568 0 0 0-40 0.064L83.072 172.672a53.12 53.12 0 0 0-33.408 49.472v85.952a772.224 772.224 0 0 0 334.848 636.544l97.28 66.88a53.12 53.12 0 0 0 60.48 0l97.216-66.88a772.224 772.224 0 0 0 334.848-636.544V222.08a53.12 53.12 0 0 0-33.28-49.472z m-30.656 135.424a708.224 708.224 0 0 1-307.136 583.744L512 954.56l-91.2-62.72a708.224 708.224 0 0 1-307.2-583.744V229.312L512 67.904l398.336 161.408z\" fill=\"#575869\" p-id=\"3466\" /><path d=\"M308.352 444.096a32 32 0 1 0-45.248 45.248l180.992 181.056a32 32 0 0 0 45.248 0l271.552-271.552a32 32 0 0 0-45.248-45.248L466.752 602.496z\" fill=\"#575869\" p-id=\"3467\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/auth-phone.svg
// module id = XyLj
// module chunks = 61